/* eslint-disable max-len */
import React, { useEffect, useState } from 'react'
import ReactModal from 'react-modal'
import CheckboxComponent from './CheckboxComponent'
import ThreeDotsLoader from '../../Components/LoadingDots';

function ResponsiveFilter({ Filters, setfilters, generateUrl, handleClear, loading, handleDate, setresponsivePopup, responsivePopup, loading1, setloading }) {
    const [toggle, settoggle] = useState(false)
    useEffect(() => {
        if (responsivePopup === true) {
            const datepickerEl = document.getElementById("datepickerId");
            const datepickerEl1 = document.getElementById("datepickerId1");
            datepickerEl && new Datepicker(datepickerEl, {});
            datepickerEl1 && new Datepicker(datepickerEl1, {});
        }
    }, [responsivePopup, toggle]);

    return (
        <ReactModal isOpen={responsivePopup}>
            <div className={`modal fade fixed top-0 left-0 show w-full h-full outline-none overflow-x-hidden overflow-y-auto ${responsivePopup ? 'show' : 'hidden'}`} id="filtermodal" tabIndex="-1" aria-labelledby="deactivateOfferModal" aria-modal="true" role="dialog">
                <div className="modal-dialog modal-dialog-centered relative w-auto pointer-events-none sm:max-w-[441px] mx-auto px-2.5" style={{ margin: 'auto' }}>
                    <div className="modal-content border-none shadow-lg relative flex flex-col w-full pointer-events-auto bg-white bg-clip-padding rounded-md outline-none text-current">
                        <div className="modal-header flex flex-shrink-0 items-center justify-between pt-[26px] rounded-t-md">
                            <button type="button"
                                onClick={() => setresponsivePopup(false)}
                                className="btn-close1 box-content w-4 h-4 p-1 text-black border-none rounded-none opacity-50 focus:shadow-none focus:outline-none focus:opacity-100 hover:text-black hover:opacity-75 hover:no-underline absolute top-4 right-6"
                                data-bs-dismiss="modal" aria-label="Close">
                            </button>
                        </div>
                        <div className="bg-white p-5 rounded-lg cursor-pointer">
                            <div className="flex justify-between items-center">
                                <p className="text-[#15090E] font-bold text-lg">Filter by</p>
                                <p className="text-[#ED1C24] font-semibold text-xs cursor-pointer" onClick={() => handleClear()}>Clear All</p>
                            </div>
                            <div className="overflow-auto">
                                <p className="text-[#555259] font-bold text-xs7 mt-5">Offer Type</p>
                                <ul>
                                    <li>
                                        <div className="px-1 mt-4">
                                            <div className="relative flex items-center">
                                                <CheckboxComponent type="Special" Filters={Filters} setfilters={setfilters} />
                                                <label htmlFor="checkbox-1" className="pl-3 text-base font-normal text-[#555259]">Special Offers</label>
                                            </div>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="px-1 mt-4">
                                            <div className="relative flex items-center">
                                                <CheckboxComponent type="Standard" Filters={Filters} setfilters={setfilters} />
                                                <label htmlFor="checkbox-2" className="pl-3 text-base font-normal text-[#555259]">Standard Offers</label>
                                            </div>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="px-1 mt-4">
                                            <div className="relative flex items-center">
                                                <CheckboxComponent type="Special Recurring" Filters={Filters} setfilters={setfilters} />
                                                <label htmlFor="checkbox-22" className="pl-3 text-base font-normal text-[#555259] cursor-pointer">Special Recurring Offers</label>
                                            </div>
                                        </div>
                                    </li>
                                </ul>
                                <p className="text-[#555259] font-bold text-xs7 mt-5">Expiring on</p>
                                <div className="flex items-center mt-3 filter-date" onClick={() => settoggle(!toggle)} >
                                    <div className="relative w-1/2 ">
                                        <label className="text-[#555259] font-normal text-xs2">Start Date</label>
                                        <img src="/images/down-arrow.svg" alt="icon" className="absolute top-[34px] right-3 cursor-pointer" />
                                        <input
                                            value={Filters.start_date}
                                            onSelect={(e) => {
                                                handleDate('start_date', e.target.value);
                                            }}
                                            datepicker
                                            datepicker-autohide
                                            type="text"
                                            id="datepickerId"
                                            className="cursor-pointer h-[38px] w-full rounded-lg outline-0 border border-[#B1B4B7] bg-[#FFFFFF] font-semibold text-[#090406] px-2.5 placeholder:font-normal placeholder:text-[#808285]"
                                            placeholder="Select Date"
                                        />
                                    </div>
                                    <p className="text-base font-normal text-[#555259] px-2.5"></p>
                                    <div className="relative w-1/2">
                                        <label className="text-[#555259] font-normal text-xs2">End Date</label>
                                        <img src="/images/down-arrow.svg" alt="icon" className="absolute top-[34px] right-3 cursor-pointer" />
                                        <input
                                            value={Filters.end_date}
                                            onSelect={(e) => {
                                                handleDate('end_date', e.target.value);
                                            }} datepicker
                                            datepicker-autohide
                                            type="text"
                                            id="datepickerId1"
                                            className="cursor-pointer h-[38px] w-full rounded-lg outline-0 border border-[#B1B4B7] bg-[#FFFFFF] font-semibold text-[#090406] px-2.5 placeholder:font-normal placeholder:text-[#808285] z-100"
                                            placeholder="Select Date"
                                        />
                                    </div>
                                </div>
                                <button
                                    onClick={() => {
                                        setloading(true);
                                        setTimeout(() => {
                                            setloading(false)
                                        }, 1000);
                                        generateUrl()
                                    }} type="button" className="bg-[#555259] h-10 w-full rounded-lg text-[#FFFFFF] font-semibold text-sm mt-10 flex justify-center items-center">
                                    {!loading1 ? 'Apply Filter' : <ThreeDotsLoader />}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </ReactModal>
    )
}

export default ResponsiveFilter